// mapbox-gl shim to export MercatorCoordinate as a named export.
// react-three-map does `import { MercatorCoordinate } from "mapbox-gl"`.
//
// mapbox-gl v3 has "type": "module" in package.json but ships a UMD bundle.
// Webpack treats it as ESM due to the package.json flag, causing require()
// to return an empty object. We require the dist file directly and force
// webpack to treat it as CJS via the javascript/auto rule in craco.config.js.
const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

const lib = mapboxgl.default || mapboxgl;
const MercatorCoordinate = mapboxgl.MercatorCoordinate ?? lib.MercatorCoordinate;

if (!MercatorCoordinate) {
  throw new Error(
    'mapbox-gl-shim: MercatorCoordinate is unavailable. ' +
      'Check that mapbox-gl/dist/mapbox-gl.js is treated as javascript/auto in craco.config.js.',
  );
}

exports.__esModule = true;
exports.default = lib;
exports.MercatorCoordinate = MercatorCoordinate;
